export default __webpack_public_path__ + "ccb195b5121faa3240d78e4947e9aa24.jpg";